declare global {
    interface Window {
        __ENV__?: { 
            REACT_APP_API_BASE_URL?: string;
            APP_ENV?: string;
            REACT_APP_APP_MODE?: string;
            REACT_APP_TURNSTILE_SITE_KEY?: string;
            REACT_APP_SERVER_TAG_SUGGESTIONS?: string;
            REACT_APP_VAPID_PUBLIC_KEY?: string;
        };
    }
}

const getRuntimeApiBaseUrl = (): string | undefined => {
    if (typeof window === 'undefined') return undefined;
    return window.__ENV__?.REACT_APP_API_BASE_URL;
};

const getRuntimeAppEnv = (): string | undefined => {
    if (typeof window === 'undefined') return undefined;
    return window.__ENV__?.APP_ENV;
};

const getRuntimeServerTagSuggestions = (): string | undefined => {
    if (typeof window === 'undefined') return undefined;
    return window.__ENV__?.REACT_APP_SERVER_TAG_SUGGESTIONS;
};

const getRuntimeVapidPublicKey = (): string | undefined => {
    if (typeof window === 'undefined') return undefined;
    return window.__ENV__?.REACT_APP_VAPID_PUBLIC_KEY;
};

/** Only `"1"` and `"true"` enable the feature (runtime env.js or build-time CRA inlining). */
const isServerTagSuggestionsEnabled = (value: string | undefined): boolean =>
    value === '1' || value === 'true';

const API_BASE_URL = getRuntimeApiBaseUrl() || process.env.REACT_APP_API_BASE_URL || '';
export const APP_ENV = getRuntimeAppEnv() || process.env.REACT_APP_APP_ENV || process.env.APP_ENV || 'production';

/** Deployment experience: 'community' (default) or 'b2b' (analytics-only dashboard). */
export const APP_MODE =
  (typeof window !== 'undefined' && window.__ENV__?.REACT_APP_APP_MODE) ||
  process.env.REACT_APP_APP_MODE ||
  'community';
export const IS_B2B = APP_MODE === 'b2b';

/** Post-login / fallback landing route for the current experience. */
export const HOME_ROUTE = IS_B2B ? '/app/communitydashboard' : '/app/community';

/** Video pipeline: opt out with REACT_APP_VIDEO_DASH_ENABLED=0 */
export const FEATURE_VIDEO_DASH_PLAYBACK =
  process.env.REACT_APP_VIDEO_DASH_ENABLED !== '0' && process.env.REACT_APP_VIDEO_DASH_ENABLED !== 'false';

/** Structured media[] from API alongside image_data; opt out with REACT_APP_USE_STRUCTURED_MEDIA=0 */
export const FEATURE_STRUCTURED_MEDIA =
  process.env.REACT_APP_USE_STRUCTURED_MEDIA !== '0' && process.env.REACT_APP_USE_STRUCTURED_MEDIA !== 'false';

/** Raw build-time value for diagnostics (Create React App inlines only vars present at compile time). */
export const REACT_APP_SERVER_TAG_SUGGESTIONS_RAW =
  process.env.REACT_APP_SERVER_TAG_SUGGESTIONS ?? '';

/** Raw runtime value from `env.js` / `window.__ENV__` (empty if unset or non-browser). */
export const REACT_APP_SERVER_TAG_SUGGESTIONS_RUNTIME_RAW =
  getRuntimeServerTagSuggestions() ?? '';

/** When true, Submit/Edit hazard UIs call POST /api/classifyHazardTags for tag suggestions (requires online). */
export const FEATURE_SERVER_TAG_SUGGESTIONS =
  isServerTagSuggestionsEnabled(REACT_APP_SERVER_TAG_SUGGESTIONS_RUNTIME_RAW) ||
  isServerTagSuggestionsEnabled(REACT_APP_SERVER_TAG_SUGGESTIONS_RAW);

/** Web Push VAPID public key (runtime env.js takes precedence over build-time CRA inlining). */
export const VAPID_PUBLIC_KEY = getRuntimeVapidPublicKey() || process.env.REACT_APP_VAPID_PUBLIC_KEY || '';

export default API_BASE_URL;
